"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectNoneRoleComment = exports.projectRoleAccessRights = exports.projectScopes = void 0;
exports.hasProjectAccessByRole = hasProjectAccessByRole;
exports.projectScopes = [
    "alerts:CUD",
    "alerts:read",
    "annotationQueueAssignments:CUD",
    "annotationQueueAssignments:read",
    "annotationQueues:CUD",
    "annotationQueues:read",
    "apiKeys:CUD",
    "apiKeys:read",
    "automations:CUD",
    "automations:read",
    "batchExports:create",
    "batchExports:read",
    "comments:CUD",
    "comments:read",
    "dashboards:CUD",
    "dashboards:read",
    "datasets:CUD",
    "datasets:read",
    "evalDefaultModel:CUD",
    "evalDefaultModel:read",
    "evalJobExecution:read",
    "evaluationRule:CUD",
    "evaluationRule:read",
    "evaluator:CUD",
    "evaluator:read",
    "experiments:read",
    "feedback:create",
    "integrations:CRUD",
    "llmApiKeys:create",
    "llmApiKeys:delete",
    "llmApiKeys:read",
    "llmApiKeys:update",
    "llmSchemas:CUD",
    "llmSchemas:read",
    "llmTools:CUD",
    "llmTools:read",
    "media:create",
    "media:read",
    "metrics:read",
    "models:CUD",
    "models:read",
    "objects:bookmark",
    "objects:publish",
    "objects:tag",
    "playground:execute",
    "project:delete",
    "project:read",
    "project:update",
    "projectAuditLogs:read",
    "projectMembers:CUD",
    "projectMembers:manageOwnership",
    "projectMembers:read",
    "promptExperiments:CUD",
    "promptExperiments:read",
    "promptProtectedLabels:CUD",
    "prompts:CUD",
    "prompts:read",
    "scoreConfigs:CUD",
    "scoreConfigs:read",
    "scores:delete",
    "scores:read",
    "scores:save",
    "sessions:read",
    "skills:CUD",
    "skills:read",
    "TableViewPresets:CUD",
    "TableViewPresets:read",
    "topics:CUD",
    "topics:read",
    "traces:create",
    "traces:delete",
    "traces:read",
];
exports.projectRoleAccessRights = {
    OWNER: [
        "alerts:CUD",
        "alerts:read",
        "annotationQueueAssignments:CUD",
        "annotationQueueAssignments:read",
        "annotationQueues:CUD",
        "annotationQueues:read",
        "apiKeys:CUD",
        "apiKeys:read",
        "automations:CUD",
        "automations:read",
        "batchExports:create",
        "batchExports:read",
        "comments:CUD",
        "comments:read",
        "dashboards:CUD",
        "dashboards:read",
        "datasets:CUD",
        "datasets:read",
        "evalDefaultModel:CUD",
        "evalDefaultModel:read",
        "evalJobExecution:read",
        "evaluationRule:CUD",
        "evaluationRule:read",
        "evaluator:CUD",
        "evaluator:read",
        "experiments:read",
        "feedback:create",
        "integrations:CRUD",
        "llmApiKeys:create",
        "llmApiKeys:delete",
        "llmApiKeys:read",
        "llmApiKeys:update",
        "llmSchemas:CUD",
        "llmSchemas:read",
        "llmTools:CUD",
        "llmTools:read",
        "media:create",
        "media:read",
        "metrics:read",
        "models:CUD",
        "models:read",
        "objects:bookmark",
        "objects:publish",
        "objects:tag",
        "playground:execute",
        "project:delete",
        "project:read",
        "project:update",
        "projectAuditLogs:read",
        "projectMembers:CUD",
        "projectMembers:manageOwnership",
        "projectMembers:read",
        "promptExperiments:CUD",
        "promptExperiments:read",
        "promptProtectedLabels:CUD",
        "prompts:CUD",
        "prompts:read",
        "scoreConfigs:CUD",
        "scoreConfigs:read",
        "scores:delete",
        "scores:read",
        "scores:save",
        "sessions:read",
        "skills:CUD",
        "skills:read",
        "TableViewPresets:CUD",
        "TableViewPresets:read",
        "topics:CUD",
        "topics:read",
        "traces:create",
        "traces:delete",
        "traces:read",
    ],
    ADMIN: [
        "alerts:CUD",
        "alerts:read",
        "annotationQueueAssignments:CUD",
        "annotationQueueAssignments:read",
        "annotationQueues:CUD",
        "annotationQueues:read",
        "apiKeys:CUD",
        "apiKeys:read",
        "automations:CUD",
        "automations:read",
        "batchExports:create",
        "batchExports:read",
        "comments:CUD",
        "comments:read",
        "dashboards:CUD",
        "dashboards:read",
        "datasets:CUD",
        "datasets:read",
        "evalDefaultModel:CUD",
        "evalDefaultModel:read",
        "evalJobExecution:read",
        "evaluationRule:CUD",
        "evaluationRule:read",
        "evaluator:CUD",
        "evaluator:read",
        "experiments:read",
        "feedback:create",
        "integrations:CRUD",
        "llmApiKeys:create",
        "llmApiKeys:delete",
        "llmApiKeys:read",
        "llmApiKeys:update",
        "llmSchemas:CUD",
        "llmSchemas:read",
        "llmTools:CUD",
        "llmTools:read",
        "media:create",
        "media:read",
        "metrics:read",
        "models:CUD",
        "models:read",
        "objects:bookmark",
        "objects:publish",
        "objects:tag",
        "playground:execute",
        "project:read",
        "project:update",
        "projectAuditLogs:read",
        "projectMembers:CUD",
        "projectMembers:read",
        "promptExperiments:CUD",
        "promptExperiments:read",
        "promptProtectedLabels:CUD",
        "prompts:CUD",
        "prompts:read",
        "scoreConfigs:CUD",
        "scoreConfigs:read",
        "scores:delete",
        "scores:read",
        "scores:save",
        "sessions:read",
        "skills:CUD",
        "skills:read",
        "TableViewPresets:CUD",
        "TableViewPresets:read",
        "topics:CUD",
        "topics:read",
        "traces:create",
        "traces:delete",
        "traces:read",
    ],
    MEMBER: [
        "alerts:CUD",
        "alerts:read",
        "annotationQueueAssignments:read",
        "annotationQueues:CUD",
        "annotationQueues:read",
        "apiKeys:read",
        "automations:read",
        "batchExports:create",
        "batchExports:read",
        "comments:CUD",
        "comments:read",
        "dashboards:CUD",
        "dashboards:read",
        "datasets:CUD",
        "datasets:read",
        "evalDefaultModel:CUD",
        "evalDefaultModel:read",
        "evalJobExecution:read",
        "evaluationRule:CUD",
        "evaluationRule:read",
        "evaluator:CUD",
        "evaluator:read",
        "llmApiKeys:read",
        "llmSchemas:CUD",
        "llmSchemas:read",
        "llmTools:CUD",
        "llmTools:read",
        "objects:bookmark",
        "objects:publish",
        "objects:tag",
        "playground:execute",
        "project:read",
        "projectMembers:read",
        "promptExperiments:CUD",
        "promptExperiments:read",
        "prompts:CUD",
        "prompts:read",
        "scoreConfigs:CUD",
        "scoreConfigs:read",
        "scores:delete",
        "scores:save",
        "skills:CUD",
        "skills:read",
        "TableViewPresets:CUD",
        "TableViewPresets:read",
        "topics:CUD",
        "topics:read",
    ],
    VIEWER: [
        "alerts:read",
        "annotationQueues:read",
        "automations:read",
        "comments:read",
        "dashboards:read",
        "datasets:read",
        "evalDefaultModel:read",
        "evalJobExecution:read",
        "evaluationRule:read",
        "evaluator:read",
        "experiments:read",
        "llmApiKeys:read",
        "llmSchemas:read",
        "llmTools:read",
        "media:read",
        "metrics:read",
        "models:read",
        "project:read",
        "promptExperiments:read",
        "prompts:read",
        "scoreConfigs:read",
        "scores:read",
        "sessions:read",
        "skills:read",
        "TableViewPresets:read",
        "topics:read",
        "traces:read",
    ],
    NONE: [],
};
exports.projectNoneRoleComment = "Do not override the organization role for this project.";
/**
 * Pure role-based access check (no session), for callers that already
 * resolved the caller's project role — e.g. the in-app agent runtime.
 * Mirrors the role branch of web's `hasProjectAccess`.
 */
function hasProjectAccessByRole(p) {
    if (p.admin)
        return true;
    return exports.projectRoleAccessRights[p.role].includes(p.scope);
}
